/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';

const makeFailureNoticeStyles = () => ({
  container: css({ maxWidth: 640, margin: '0 auto', textAlign: 'center' }),
  // Phone-in-a-circle mirrors the confirmation-tick styling (the same
  // stakeholder-greenlit MVP hex); per the ticket only the glyph differs.
  icon: css({
    width: 80,
    height: 80,
    margin: '0 auto 15px',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#1d917a26',
    color: '#1d917a',
  }),
  // Heading + subheading mirror the confirmation page so the failure page
  // matches the design template: a bold heading over a muted subheading.
  heading: css({
    marginTop: 10,
    '& h6': { fontWeight: 900, fontSize: 30, lineHeight: 1 },
  }),
  subheading: css({ margin: '10px 0 15px 0' }),
});

export default makeFailureNoticeStyles;
